import React from 'react';
import { LEGAL_CONTACT } from '../../content/termsContent';

const ContactLinks = ({ className = '' }) => (
  <address className={`legal-contact ${className}`.trim()}>
    <p>
      <span className="legal-contact__label">Email:</span>{' '}
      <a href={`mailto:${LEGAL_CONTACT.email}`} className="legal-contact__link">
        {LEGAL_CONTACT.email}
      </a>
    </p>
    <p>
      <span className="legal-contact__label">Phone:</span>{' '}
      <a href={`tel:${LEGAL_CONTACT.phoneTel}`} className="legal-contact__link">
        {LEGAL_CONTACT.phone}
      </a>
    </p>
  </address>
);

export default ContactLinks;
